import { createContext, useContext } from 'react';
import { getCurrentBreakpoint } from './Responsive.helper';
import getResponsiveProps from './getCurrentResponsive';
export const ResponsiveContext = createContext<ResponsiveProps>(
  getResponsiveProps({
    currentBreakpoint: getCurrentBreakpoint(),
    isAppMounted: false,
  }),
);
export const useResponsive = (): ResponsiveProps => {
  const context = useContext(ResponsiveContext);

  if (context === undefined) {
    throw new Error('useResponsive must be used within a ResponsiveContext.Provider');
  }

  return context;
};
